import {
    createTranslator,
    NS,
    initI18Next,
} from "../../../../components-shared/utils/init-i18next.js";
import { ProductQrCodeScanner } from "./product-qr-code-scanner.js";
import { cartEventSubscriber } from "../../../common/pubsub/cart-event-pub-sub.js";

export class ProductQrCodeNewScan extends HTMLElement {
    constructor() {
        super();
    }

    /* #region Private */
    private scanner: ProductQrCodeScanner;
    private t = createTranslator(NS.ESTORE_CART);
    private isQrSession = () => window.location.search.includes("qr=1");

    private init() {
        const styles = document.createElement("style");
        styles.textContent = `
            product-qr-code-new-scan {
                display: none;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                text-align: center;
            }
        `;
        this.appendChild(styles);

        const mainIcon = document.createElement("div");
        mainIcon.classList.add("main-icon");
        this.appendChild(mainIcon);

        const header = document.createElement("h2");
        header.textContent = this.t("addedToCart");
        this.appendChild(header);

        this.scanner = new ProductQrCodeScanner();
        this.appendChild(this.scanner);

        const goToCartLink = document.createElement("a");
        goToCartLink.classList.add("btn", "btn-primary");
        goToCartLink.href = window.cartSettings.detailedCartPageUrl;
        goToCartLink.textContent = this.t("goToCart");

        this.appendChild(goToCartLink);
        document.body.classList.add("qr-code");
    }

    private subscribeCart() {
        cartEventSubscriber.onCartItemsAdded(() => this.show());
        cartEventSubscriber.onCartQuantityUpdated(() => this.show());
    }

    private show() {
        this.style.display = "flex";
        document.body.classList.add("qr-scan-open");
    }
    /* #endregion */

    async connectedCallback() {
        if (!this.isQrSession()) {
            this.style.display = "none";
            return;
        }

        await initI18Next(NS.ESTORE_CART);
        this.init();
        this.subscribeCart();
    }
}

customElements.define("product-qr-code-new-scan", ProductQrCodeNewScan);
